import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Section, Loader } from 'sa-ui';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { getLogs, getLogsRead, resetControlPanel } from './controlPanelActions';
import { PAGINATION_CONFIG, LOGS_READ_DELAY_MS } from './controlPanelConfig';
import messages from './controlPanelMessages';
import './ControlPanelContainer.scss';

const ControlPanelContainer = ({
  intl,
  logs,
  logsNotRead,
  showMore,
  activities,
  dispatch,
  user,
  isLoading,
}) => {
  const [state, setState] = useState({
    items: PAGINATION_CONFIG.initialItems,
    page: PAGINATION_CONFIG.initialPage,
  });
  const [loadingMore, setLoadingMore] = useState(false);

  const isStudent = user.idType === 4;

  const loadLogs = () => {
    const { page } = state;
    dispatch(getLogs({ page }));
    setTimeout(() => {
      dispatch(getLogsRead());
    }, LOGS_READ_DELAY_MS);
  };

  useEffect(() => {
    if (isStudent) {
      return undefined;
    }

    loadLogs();

    return () => {
      dispatch(resetControlPanel());
    };
  }, []);

  const handleSeeMore = () => {
    if (!showMore || loadingMore || isLoading) return;

    setLoadingMore(true);
    setState((prevState) => ({
      items: prevState.items + PAGINATION_CONFIG.incrementBy,
      page: prevState.page + 1,
    }));
  };

  useEffect(() => {
    if (isStudent || state.page <= 0) {
      return;
    }

    loadLogs();
  }, [state.page]);

  useEffect(() => {
    if (!isLoading) {
      setLoadingMore(false);
    }
  }, [isLoading]);

  const isSeeMoreLoading = loadingMore || (isLoading && state.page > 0);

  const items = logs.filter((el, index) => index < state.items);

  return (
    <Section title={intl.formatMessage(messages.title)}>
      <div id="control-panel-container">
        <div className="card">
          <div className="card-header">
            <div className="card-header-title">{intl.formatMessage(messages.pendingTasks)}</div>
          </div>
          <div className="card-body">
            {items.map((l, i) => (
              <div className="card-item" key={i}>
                <div className="card-item-label">
                  <p dangerouslySetInnerHTML={{ __html: l.log }} />
                  {l.comments &&
                    l.comments.trim() !== '' &&
                    l.type !== 'report_download' &&
                    l.action !== 'logout' &&
                    l.action !== 'login' && (
                      <p>
                        <b>{intl.formatMessage(messages.comments)}:</b> <em>{l.comments}</em>
                      </p>
                    )}
                  <p>
                    <strong>{intl.formatMessage(messages.executedBy)}:</strong> {l.userName}
                  </p>
                </div>
                <div className="card-item-details">
                  <div className="card-item-deadline">{l.date}</div>
                  {l.link && (
                    <Link to={`/${l.link}`}>
                      <div className="card-item-action">
                        <i className="pe-7s-search pending" />
                        <span className="pending">{intl.formatMessage(messages.see)}</span>
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
          {logs.length > 0 && (showMore || isSeeMoreLoading) && (
            <div
              className={`card-footer ${isSeeMoreLoading ? 'is-loading' : 'link'}`}
              onClick={handleSeeMore}
            >
              {isSeeMoreLoading ? (
                <span className="see-more-loading">
                  <span className="see-more-spinner" aria-hidden="true" />
                  {intl.formatMessage(messages.loading)}
                </span>
              ) : (
                intl.formatMessage(messages.seemore)
              )}
            </div>
          )}
        </div>
      </div>
    </Section>
  );
};

function mapStateToProps({ app, controlPanel }) {
  return {
    user: app.user,
    ...controlPanel,
  };
}

export default compose(injectIntl, connect(mapStateToProps))(ControlPanelContainer);
